<template>
  <NSelect class="n-crypto-token" v-bind="attrs" :get-popup-container="node => node.parentNode" />
</template>

<script setup>
import {useBootstrap} from '@front/hooks';
import {computed, watch} from 'vue';

const props = defineProps({
  value: undefined,
  bank: String,
});

const emit = defineEmits(['update:value']);

const { ENUMS } = useBootstrap();

const attrs = computed(() => ({
  options: ENUMS.value.CryptoTokenType,
  label: 'cryptoTokenType',
  // ...useAttrs(),
  value: props.value,
  'onUpdate:value': v => emit('update:value', v),
}));

watch(
  () => {},
  to => {
    if (props.value && !to.find(o => o.value === props.value)) {
      emit('update:value', null);
    }
  },
);
</script>

<script>
export default {
  name: 'NCryptoTokenType',
};
</script>
